/* eslint-disable react/no-unused-class-component-methods */

'use strict';

import React, { Component } from 'react'

import { BrowserRouter as Router, Route, Link, Switch } from 'react-router-dom'

import launch from './launch'

import DashboardPage     from '@Page/DashboardPage'
import RedirectHomePage  from '@Page/RedirectHomePage'
import UserPage          from '@Page/UserPage'
import LoginPage         from '@Page/LoginPage'
import AppTokenLoginPage from '@Page/AppTokenLoginPage'

import RegistrationConfirmationPage from '@Page/RegistrationConfirmationPage'
import RegistrationPage             from '@Page/RegistrationPage'
import PasswordRecoveryPage         from '@Page/PasswordRecoveryPage'
import NewPasswordPage              from '@Page/NewPasswordPage'

import ECFrontDashboardPage from '@Page/FrontEC/ECFrontDashboardPage'

import NewsletterPage from '@Page/EC/NewsletterPage'

import RGPDConsentPage from '@Page/EC/RGPDConsentPage'

/**
 * EC
 **/
import NewECPage from '@Page/EC/NewECPage'
import ECsPage   from '@Page/EC/ECsPage'
import ECPage    from '@Page/EC/ECPage'

import AdminAddECAbondementPage from '@Page/EC/AdminAddECAbondementPage'

/**
 * Catalog
 **/
import CategoriesPage       from '@Page/Catalog/CategoriesPage'
import CategoryPage         from '@Page/Catalog/CategoryPage'
import NewCategoryPage      from '@Page/Catalog/NewCategoryPage'

import TicketPage           from '@Page/Catalog/TicketPage'
import TicketsPage          from '@Page/Catalog/TicketsPage'
import NewTicketPage        from '@Page/Catalog/NewTicketPage'

import ProviderPage         from '@Page/Catalog/ProviderPage'
import ProvidersPage        from '@Page/Catalog/ProvidersPage'
import NewProviderPage      from '@Page/Catalog/NewProviderPage'

import PartnerPage          from '@Page/Catalog/PartnerPage'
import PartnersPage         from '@Page/Catalog/PartnersPage'
import NewPartnerPage       from '@Page/Catalog/NewPartnerPage'

import CustomQuotesPage     from '@Page/Catalog/CustomQuotesPage'
import CustomQuotePage      from '@Page/Catalog/CustomQuotePage'
import NewCustomQuotePage   from '@Page/Catalog/NewCustomQuotePage'

import ProductFamiliesPage  from '@Page/Catalog/ProductFamiliesPage'
import ProductFamilyPage    from '@Page/Catalog/ProductFamilyPage'
import NewProductFamilyPage from '@Page/Catalog/NewProductFamilyPage'

/**
 * Config
 **/
import ConfigPage          from '@Page/Config/ConfigPage'

import ArtistPage          from '@Page/Config/ArtistPage'
import ArtistsPage         from '@Page/Config/ArtistsDashboardPage'
import NewArtistPage       from '@Page/Config/NewArtistPage'

import PlacePage           from '@Page/Config/PlacePage'
import PlacesPage          from '@Page/Config/PlacesPage'
import NewPlacePage        from '@Page/Config/NewPlacePage'

import PlaceThemePage      from '@Page/Config/PlaceThemePage'
import PlaceThemesPage     from '@Page/Config/PlaceThemesPage'
import NewPlaceThemePage   from '@Page/Config/NewPlaceThemePage'

import PositionPage        from '@Page/Config/PositionPage'
import PositionsPage       from '@Page/Config/PositionsPage'
import NewPositionPage     from '@Page/Config/NewPositionPage'

import PublicPage          from '@Page/Config/PublicPage'
import PublicsPage         from '@Page/Config/PublicsPage'
import NewPublicPage       from '@Page/Config/NewPublicPage'

import AgePage             from '@Page/Config/AgePage'
import AgesPage            from '@Page/Config/AgesPage'
import NewAgePage          from '@Page/Config/NewAgePage'

import ThemePage           from '@Page/Config/ThemePage'
import ThemesPage          from '@Page/Config/ThemesPage'
import NewThemePage        from '@Page/Config/NewThemePage'

import TicketTypePage      from '@Page/Config/TicketTypePage'
import TicketTypesPage     from '@Page/Config/TicketTypesPage'
import NewTicketTypePage   from '@Page/Config/NewTicketTypePage'

import UserFunctionPage    from '@Page/Config/UserFunctionPage'
import UserFunctionsPage   from '@Page/Config/UserFunctionsPage'
import NewUserFunctionPage from '@Page/Config/NewUserFunctionPage'

import SynerQuizzDashboardPage from '@Page/Config/SynerQuizzDashboardPage'
import NewSynerQuizzPage       from '@Page/Config/NewSynerQuizzPage'
import SynerQuizzPage          from '@Page/Config/SynerQuizzPage'

import NationalBrandDashboardPage from '@Page/Config/NationalBrandDashboardPage'
import NewNationalBrandPage       from '@Page/Config/NewNationalBrandPage'
import NationalBrandPage          from '@Page/Config/NationalBrandPage'

/**
 * User
 **/
import UsersDashboardPage from '@Page/User/UsersDashboardPage'
import NewUserPage        from '@Page/User/NewUserPage'

/**
 * EC Front
 */
import CartPage from '@Page/FrontEC/CartPage'

import OrderPage           from '@Page/FrontEC/OrderPage'
import OrdersInfosListPage from '@Page/FrontEC/OrdersInfosListPage'
import ECBillsPage         from '@Page/FrontEC/ECBillsPage'

import OrderConfirmationPage from '@Page/FrontEC/OrderConfirmationPage'
import ECFrontUserPage       from '@Page/FrontEC/UserPage'
import SynerKadoPage         from '@Page/FrontEC/SynerKadoPage'
import ECPartnersSpace       from '@Page/FrontEC/ECPartnersSpace'
import NewContentPage        from '@Page/FrontEC/NewContentPage'

import UserCardPage from '@Page/FrontEC/UserCardPage'

import TutorialsPage from '@Page/FrontEC/TutorialsPage'
import TutorialPage  from '@Page/FrontEC/TutorialPage'

import MyECPage           from '@Page/FrontEC/MyECPage'
import MyECInfosPage      from '@Page/FrontEC/MyECInfosPage'
import MeetingRecordsPage from '@Page/FrontEC/MeetingRecordsPage'
import MeetingRecordPage  from '@Page/FrontEC/MeetingRecordPage'

/**
 * Front Catalog
 **/
import FrontCatalogPage     from '@Page/Catalog/Front/CatalogPage'
import FrontProductPage     from '@Page/Catalog/Front/ProductPage'
import FrontAllCatalogPage  from '@Page/Catalog/Front/AllCatalogPage'

import FrontPartnersPage    from '@Page/Catalog/Front/PartnersPage'
import FrontPartnerPage     from '@Page/Catalog/Front/PartnerPage'

import FrontArtistsPage     from '@Page/Catalog/Front/ArtistsPage'
import FrontArtistPage      from '@Page/Catalog/Front/ArtistPage'

import FrontPlacePage from '@Page/Catalog/Front/PlacePage'

import FrontHolidaysPage    from '@Page/Catalog/Front/FrontHolidaysPage'
import FrontWebPartnersPage from '@Page/Catalog/Front/FrontWebPartnersPage'
import GiftProductsPage     from '@Page/Catalog/Front/GiftProductsPage'
import PromoPartnersPage    from '@Page/Catalog/Front/PromoPartnersPage'


/**
 * EC Admin
*/
import ECColorPage  from '@Page/ECBackOffice/ECColorPage'
import ECUsersPage  from '@Page/ECBackOffice/ECUsersPage'
import ECStatsPage  from '@Page/ECBackOffice/ECStatsPage'
import ECConfigPage from '@Page/ECBackOffice/ECConfigPage'
import ECCodePage   from '@Page/ECBackOffice/ECCodePage'
import ECInfosPage  from '@Page/ECBackOffice/ECInfosPage'

import ECProductAbondementsPage from '@Page/ECBackOffice/ECProductAbondementsPage'
import ECProductAbondementPage  from '@Page/ECBackOffice/ECProductAbondementPage'
import ECUsersAbondementsPage   from '@Page/ECBackOffice/ECUsersAbondementsPage'

import UpdateECProductAbondementPage from '@Page/ECBackOffice/UpdateECProductAbondementPage'

import ECAdminAbondementHistoryPage from '@Page/ECBackOffice/ECAdminAbondementHistoryPage'

import NewMeetingRecordPage      from '@Page/ECBackOffice/NewMeetingRecordPage'
import UpdateECMeetingRecordPage from '@Page/ECBackOffice/UpdateECMeetingRecordPage'

/**
 * Blog
 **/

import AdminBlogPage         from '@Page/Blog/AdminBlogPage'
import AdminBlogsPage        from '@Page/Blog/AdminBlogsPage'
import NewAdminBlogPage      from '@Page/Blog/NewAdminBlogPage'
import ECBlogUpdatePage      from '@Page/Blog/ECBlogUpdatePage'
import AdminLegalBlogPage    from '@Page/Blog/AdminLegalBlogPage'
import AdminLegalBlogsPage   from '@Page/Blog/AdminLegalBlogsPage'
import NewAdminLegalBlogPage from '@Page/Blog/NewAdminLegalBlogPage'

import NewAdminAdBlogPage from '@Page/Blog/NewAdminAdBlogPage'
import AdminAdBlogsPage   from '@Page/Blog/AdminAdBlogsPage'
import AdminAdBlogPage    from '@Page/Blog/AdminAdBlogPage'

import AdBlogPage    from '@Page/Blog/AdBlogPage'
import AdBlogsPage   from '@Page/Blog/AdBlogsPage'

import BlogPage    from '@Page/Blog/BlogPage'
import BlogsPage   from '@Page/Blog/BlogsPage'
import NewBlogPage from '@Page/Blog/NewBlogPage'

import ECAdminBlogPage       from '@Page/ECBackOffice/AdminBlogPage'
import ECAdminBlogsPage      from '@Page/ECBackOffice/AdminBlogsPage'
import ECAdminLegalBlogsPage from '@Page/ECBackOffice/ECAdminLegalBlogsPage'
import ECAdminLegalBlogPage  from '@Page/ECBackOffice/ECAdminLegalBlogPage'

import TutorialsDashboardPage from '@Page/ECBackOffice/TutorialsDashboardPage'
import UpdateTutorialPage     from '@Page/ECBackOffice/UpdateTutorialPage'
import NewTutorialPage        from '@Page/ECBackOffice/NewTutorialPage'
import ECAdminExchangePage    from '@Page/ECBackOffice/ECAdminExchangePage'

/**
 * Orders Management
 */
import DiscountCodesDashboardPage from '@Page/Order/DiscountCodesDashboardPage'
import GroupedCodesDashboardPage  from '@Page/Order/GroupedCodesDashboardPage'
import DiscountCodesExamplePage   from '@Page/Order/DiscountCodesExamplePage'
import CreditNotesDashboardPage   from '@Page/Order/CreditNotesDashboardPage'
import DiscountCodesImportPage    from '@Page/Order/DiscountCodesImportPage'
import OrdersByThemeExportPage    from '@Page/Order/OrdersByThemeExportPage'
import ProductsManagementPage     from '@Page/Order/ProductsManagementPage'
import PaymentsDashboardPage      from '@Page/Order/Payments/PaymentsDashboardPage'
import TicketsManagementPage      from '@Page/Order/TicketsManagementPage'
import OrdersManagementPage       from '@Page/Order/OrdersManagementPage'
import BillsDashboardPage         from '@Page/Order/BillsDashboardPage'
import NewCreditNotePage          from '@Page/Order/NewCreditNotePage'
import NewBillPage                from '@Page/Order/NewBillPage'
import OrdersExportPage           from '@Page/Order/OrdersExportPage'
import ResetOrderPage             from '@Page/Order/ResetOrderPage'
import NewPaymentPage             from '@Page/Order/Payments/NewPaymentPage'
import TPEimportPage              from '@Page/Order/TPEimportPage'

/*
 * Services
**/
import ServicesDashboardPage from '@Page/Order/ServicesDashboardPage'
import UpdateServicePage     from '@Page/Order/UpdateServicePage'
import NewServicePage        from '@Page/Order/NewServicePage'

/**
 * Renouvellement CSE
**/
import ECRenewalPage from '@Page/ECBackOffice/ECRenewalPage'

/**
 * Partners
 */
import PartnerAccessPage       from '@Page/Partners/PartnerAccessPage'
import PartnerModificationPage from '@Page/Partners/PartnerModificationPage'
import PartnersRenewalPage     from '@Page/Partners/PartnersRenewalPage'

import ExportPrivateSale from '@Page/PrivateSale/ExportPrivateSale'
import PrivateSaleList   from '@Page/PrivateSale/PrivateSaleList'
import PrivateSalePage   from '@Page/PrivateSale/PrivateSalePage'
import EditPrivateSale   from '@Page/PrivateSale/EditPrivateSale'

import NotAllowedPage  from '@Page/NotAllowedPage'
import MaintenancePage from '@Page/MaintenancePage'
import CancelLoginPage from '@Page/CancelLoginPage'

import SorewardsImportPage from '@Page/Sorewards/SorewardsImportPage'

const app = window.app;

const qwest = window.qwest;

export default class Application extends Component
{
	constructor (props)
	{
		super(props);

		this.state = { };

		this.routes =
		{
			/*
				=========================================================
				-------------------------  Test -------------------------
				=========================================================
			*/

			'/dashboard':
			{
				component: DashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE':
			{
				component: RedirectHomePage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue':
			{
				component: RedirectHomePage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-commandes':
			{
				component: RedirectHomePage,
				permissions: ['Membre de synergies']
			},

			'/configuration':
			{
				component: ConfigPage,
				permissions: ['Membre de synergies']
			},

			/*
				=========================================================
				----------------- Back office Synergies -----------------
				=========================================================
			*/

			'/export-newsletter':
			{
				component: NewsletterPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				---------- Orders Management ----------
				---------------------------------------
			*/

			'/gestion-des-commandes/commandes':
			{
				component: OrdersManagementPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-commandes/billetterie-spectacle':
			{
				component: TicketsManagementPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-commandes/billetterie':
			{
				component: ProductsManagementPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-commandes/reinitialiser':
			{
				component: ResetOrderPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-commandes/codes-promo':
			{
				component: DiscountCodesDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-commandes/codes-promo-groupes':
			{
				component: GroupedCodesDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/import-codes-promo':
			{
				component: DiscountCodesImportPage,
				permissions: ['Membre de synergies']
			},

			'/exemple-codes-promo':
			{
				component: DiscountCodesExamplePage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--------------- Billing ---------------
				---------------------------------------
			*/

			'/gestion-des-reglements':
			{
				component: PaymentsDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-reglements/nouveau':
			{
				component: NewPaymentPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-avoirs':
			{
				component: CreditNotesDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-avoirs/nouveau':
			{
				component: NewCreditNotePage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-factures':
			{
				component: BillsDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-factures/nouvelle':
			{
				component: NewBillPage,
				permissions: ['Membre de synergies']
			},

			'/export-des-commandes':
			{
				component: OrdersExportPage,
				permissions: ['Membre de synergies']
			},

			'/import-TPE':
			{
				component: TPEimportPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-RGPD':
			{
				component: RGPDConsentPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-services':
			{
				component: ServicesDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-services/nouveau':
			{
				component: NewServicePage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-services/:id':
			{
				component: UpdateServicePage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--------- Providers Management --------
				---------------------------------------
			*/

			'/import-sorewards':
			{
				component: SorewardsImportPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--------- Providers Management --------
				---------------------------------------
			*/

			'/gestion-du-catalogue/fournisseurs':
			{
				component: ProvidersPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/fournisseurs/:provider':
			{
				component: ProviderPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/nouveau-fournisseur':
			{
				component: NewProviderPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/export-par-theme':
			{
				component: OrdersByThemeExportPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--------------- Partners --------------
				---------------------------------------
			*/

			'/partenaires':
			{
				component: PartnersPage,
				permissions: ['Membre de synergies']
			},

			'/partenaires/:partner':
			{
				component: PartnerPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/nouveau-partenaire':
			{
				component: NewPartnerPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--------- Categories Management -------
				---------------------------------------
			*/

			'/gestion-du-catalogue/categories':
			{
				component: CategoriesPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/categories/:category':
			{
				component: CategoryPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/nouvelle-categorie':
			{
				component: NewCategoryPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				---------- Catalog Management ---------
				---------------------------------------
			*/

			'/gestion-du-catalogue/billets/:billet':
			{
				component: TicketPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/billets':
			{
				component: TicketsPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/nouveau-billet':
			{
				component: NewTicketPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				-------------- Quotation --------------
				---------------------------------------
			*/

			'/gestion-du-catalogue/demandes-de-devis':
			{
				component: CustomQuotesPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/demandes-de-devis/:id':
			{
				component: CustomQuotePage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/nouvelle-demande-de-devis':
			{
				component: NewCustomQuotePage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--------------- Family ----------------
				---------------------------------------
			*/

			'/gestion-du-catalogue/familles-de-produits':
			{
				component: ProductFamiliesPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/familles-de-produits/:id':
			{
				component: ProductFamilyPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-du-catalogue/nouvelle-famille-de-produits':
			{
				component: NewProductFamilyPage,
				permissions: ['Membre de synergies']
			},

			/*
				---------------------------------------
				--- Enterprise Committee Management ---
				---------------------------------------
			*/

			'/gestion-des-CE/les-CE':
			{
				component: ECsPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/les-CE/:CE':
			{
				component: ECPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/nouveau-CE':
			{
				component: NewECPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/membres':
			{
				component: UsersDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/membres/:membre':
			{
				component: UserPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/nouveau-membre':
			{
				component: NewUserPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/abondements-CE':
			{
				component: ECsPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/abondements-CE/:EC_id':
			{
				component: AdminAddECAbondementPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				--------------- Artistes ---------------
				----------------------------------------
			*/

			'/configuration/artistes':
			{
				component: ArtistsPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/artistes/:id':
			{
				component: ArtistPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouvel-artiste':
			{
				component: NewArtistPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				----------------- Lieux ----------------
				----------------------------------------
			*/

			'/configuration/lieux':
			{
				component: PlacesPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/lieux/:id':
			{
				component: PlacePage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouveau-lieu':
			{
				component: NewPlacePage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				--------------- Placement --------------
				----------------------------------------
			*/

			'/configuration/placements':
			{
				component: PositionsPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/placements/:id':
			{
				component: PositionPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouveau-placement':
			{
				component: NewPositionPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				--------------- Publics ----------------
				----------------------------------------
			*/

			'/configuration/publics':
			{
				component: PublicsPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/publics/:id':
			{
				component: PublicPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouveau-public':
			{
				component: NewPublicPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				----------------- Ages -----------------
				----------------------------------------
			*/

			'/configuration/tranches-d-ages':
			{
				component: AgesPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/tranches-d-ages/:id':
			{
				component: AgePage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouvel-age':
			{
				component: NewAgePage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				---------------- Themes ----------------
				----------------------------------------
			*/

			'/configuration/themes':
			{
				component: ThemesPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/themes/:id':
			{
				component: ThemePage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouveau-theme':
			{
				component: NewThemePage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				--------- Thèmes de principaux ---------
				----------------------------------------
			*/

			'/configuration/themes-principaux':
			{
				component: PlaceThemesPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/themes-principaux/:id':
			{
				component: PlaceThemePage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouveau-theme-principal':
			{
				component: NewPlaceThemePage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				----------- Types de billet ------------
				----------------------------------------
			*/

			'/configuration/types-de-billet':
			{
				component: TicketTypesPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/types-de-billet/:id':
			{
				component: TicketTypePage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouveau-type-de-billet':
			{
				component: NewTicketTypePage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				-------------- Syner'Quiz --------------
				----------------------------------------
			*/

			'/configuration/syner-quizz':
			{
				component: SynerQuizzDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/syner-quizz/nouveau':
			{
				component: NewSynerQuizzPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/syner-quizz/:id':
			{
				component: SynerQuizzPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				--------- Enseignes nationales ---------
				----------------------------------------
			*/

			'/configuration/enseignes-nationales':
			{
				component: NationalBrandDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/enseignes-nationales/nouvelle-enseigne':
			{
				component: NewNationalBrandPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/enseignes-nationales/:id':
			{
				component: NationalBrandPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				-------------- Fonctions ---------------
				----------------------------------------
			*/

			'/configuration/fonctions':
			{
				component: UserFunctionsPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/fonctions/:id':
			{
				component: UserFunctionPage,
				permissions: ['Membre de synergies']
			},

			'/configuration/nouvelle-fonction':
			{
				component: NewUserFunctionPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				----------- Advertising Blog -----------
				----------------------------------------
			*/

			'/gestion-des-CE/blog-promos':
			{
				component: AdminAdBlogsPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/blog-promos/nouvel-article':
			{
				component: NewAdminAdBlogPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/blog-promos/:id':
			{
				component: AdminAdBlogPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				--------- Synergies Admin Blog ---------
				----------------------------------------
			*/

			'/gestion-des-CE/blog':
			{
				component: AdminBlogsPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/blog/:id':
			{
				component: AdminBlogPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/nouvel-article-de-blog':
			{
				component: NewAdminBlogPage,
				permissions: ['Membre de synergies']
			},

			/*
				----------------------------------------
				-------------- Legal Blog --------------
				----------------------------------------
			*/

			'/gestion-des-CE/blog-juridique':
			{
				component: AdminLegalBlogsPage,
				permissions: ['Membre de synergies', 'legal_writer']
			},

			'/gestion-des-CE/blog-juridique/:id':
			{
				component: AdminLegalBlogPage,
				permissions: ['Membre de synergies', 'legal_writer']
			},

			'/gestion-des-CE/nouvel-article-de-blog-juridique':
			{
				component: NewAdminLegalBlogPage,
				permissions: ['Membre de synergies', 'legal_writer']
			},

			/*
				----------------------------------------
				--------------- Tutorials --------------
				----------------------------------------
			*/

			'/gestion-des-CE/tutoriels':
			{
				component: TutorialsDashboardPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/nouveau-tutoriel':
			{
				component: NewTutorialPage,
				permissions: ['Membre de synergies']
			},

			'/gestion-des-CE/tutoriels/:id':
			{
				component: UpdateTutorialPage,
				permissions: ['Membre de synergies']
			},

			/*
				=========================================================
				------------ Back office Enterprise Committee -----------
				=========================================================
			*/

			/*
				----------------------------------------
				------------  Configuration ------------
				----------------------------------------
			*/

			'/espace-administrable':
			{
				component: ECFrontDashboardPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/couleur':
			{
				component: ECColorPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/configuration':
			{
				component: ECConfigPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/utilisateurs':
			{
				component: ECUsersPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/reporting':
			{
				component: ECStatsPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/blog-synergies':
			{
				component: ECAdminBlogsPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/blog-synergies/:id':
			{
				component: ECAdminBlogPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/blog-juridique':
			{
				component: ECAdminLegalBlogsPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/blog-juridique/:id':
			{
				component: ECAdminLegalBlogPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/nouvel-article-de-blog':
			{
				component: NewBlogPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/modifier-un-article-de-blog/:id':
			{
				component: ECBlogUpdatePage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/mon-code-CE':
			{
				component: ECCodePage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/informations-du-CE':
			{
				component: ECInfosPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/abondement-utilisateur':
			{
				component: ECUsersAbondementsPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/abondement-produit':
			{
				component: ECProductAbondementPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/abondements-produit':
			{
				component: ECProductAbondementsPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/abondements-produit/:id':
			{
				component: UpdateECProductAbondementPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/abondement-CE':
			{
				component: ECAdminAbondementHistoryPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/espace-administrable/mes-documents-synergies':
			{
				component: ECAdminExchangePage,
				permissions: ['EC', 'Administrateur de CE']
			},

			/*
				=========================================================
				-------------------- Ventes privées ---------------------
				=========================================================
			*/

			'/VP-:slug':
			{
				component: PrivateSalePage,
				permissions:
				[
					'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/gestion-des-ventes-privees':
			{
				component: PrivateSaleList,
				permissions:
				[
					'Membre de synergies'
				]
			},

			'/gestion-des-ventes-privees/nouvelle':
			{
				component: EditPrivateSale,
				permissions:
				[
					'Membre de synergies'
				]
			},

			'/gestion-des-ventes-privees/:slug':
			{
				component: EditPrivateSale,
				permissions:
				[
					'Membre de synergies'
				]
			},

			'/gestion-des-ventes-privees/:slug/exports':
			{
				component: ExportPrivateSale,
				permissions:
				[
					'Membre de synergies'
				]
			},

			/*
				=========================================================
				----------- Front office Enterprise Committee -----------
				=========================================================
			*/

			'/accueil':
			{
				component: ECFrontDashboardPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-espace':
			{
				component: MyECPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-espace/infos-pratiques':
			{
				component: MyECInfosPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			/*
				-----------------------------------------
				---------- EC Meeting records -----------
				-----------------------------------------
			*/

			'/accueil/mon-espace/comptes-rendus-de-reunion':
			{
				component: MeetingRecordsPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-espace/comptes-rendus-de-reunion/:id':
			{
				component: MeetingRecordPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-espace/nouveau-compte-rendu-de-reunion':
			{
				component: NewMeetingRecordPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			'/accueil/mon-espace/modifier-un-compte-rendu-de-reunion/:id':
			{
				component: UpdateECMeetingRecordPage,
				permissions: ['EC', 'Administrateur de CE']
			},

			/*
				-----------------------------------------
				---------------- EC Blog ----------------
				-----------------------------------------
			*/

			'/accueil/mon-espace/blog':
			{
				component: BlogsPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-espace/blog/:id':
			{
				component: BlogPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			/*
				-----------------------------------------
				---------------- Ad Blog ----------------
				-----------------------------------------
			*/

			'/promotions':
			{
				component: AdBlogsPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/promotions/:id':
			{
				component: AdBlogPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			/*
				-----------------------------------------
				--------------- Tutorials ---------------
				-----------------------------------------
			*/

			'/accueil/mon-espace/tutoriels':
			{
				component: TutorialsPage,
				permissions:
				[
					'Membre de synergies',
					'Administrateur de CE',
					'Membre de CE',
					'EC'
				]
			},

			'/accueil/mon-espace/tutoriels/:id':
			{
				component: TutorialPage,
				permissions:
				[
					'Membre de synergies',
					'Administrateur de CE',
					'Membre de CE',
					'EC'
				]
			},

			/*
				-----------------------------------------
				-------------- Order pages --------------
				-----------------------------------------
			*/

			'/panier':
			{
				component: CartPage,
				permissions:
				[
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/panier/commander':
			{
				component: OrderPage,
				permissions:
				[
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/confirmation-de-commande':
			{
				component: OrderConfirmationPage,
				permissions:
				[
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/mes-commandes':
			{
				component: OrdersInfosListPage,
				permissions:
				[
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/mes-factures':
			{
				component: ECBillsPage,
				permissions:
				[
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			/*
				-----------------------------------------
				---------------- Catalog ----------------
				-----------------------------------------
			*/

			'/accueil/catalogue':
			{
				component: FrontCatalogPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/catalogue/:produit':
			{
				component: FrontProductPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/lieux/:lieu':
			{
				component: FrontPlacePage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/sejours-vacances':
			{
				component: FrontHolidaysPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires':
			{
				component: ECPartnersSpace,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/nouveautes':
			{
				component: NewContentPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires/partenaires':
			{
				component: FrontPartnersPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires/partenaires/:partenaire':
			{
				component: FrontPartnerPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE',
					'Partenaire'
				]
			},

			'/accueil/offres-web':
			{
				component: FrontWebPartnersPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/offres-web/:partenaire':
			{
				component: FrontPartnerPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires/codes-promotionnels':
			{
				component: PromoPartnersPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires/codes-promotionnels/:produit':
			{
				component: FrontProductPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires/bons-d-achat':
			{
				component: GiftProductsPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/espace-partenaires/bons-d-achat/:produit':
			{
				component: FrontProductPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/artistes':
			{
				component: FrontArtistsPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/artistes/:artiste':
			{
				component: FrontArtistPage
			},

			'/accueil/ma-carte-e-synergies':
			{
				component: UserCardPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/annuaire-des-partenaires':
			{
				component: DashboardPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-compte':
			{
				component: ECFrontUserPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/mon-compte/syner-kado':
			{
				component: SynerKadoPage,
				permissions:
				[
					'Administrateur de CE',
					'Membre de CE'
				]
			},

			'/accueil/catalogue-synergies':
			{
				component: FrontAllCatalogPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE'
				]
			},

			/*
				=========================================================
				------------------- Renouvellement CSE ------------------
				=========================================================
			*/

			'/accueil/renouvellement-CSE':
			{
				component: ECRenewalPage,
				permissions:
				[
					'EC', 'Administrateur de CE'
				]
			},

			/*
				=========================================================
				------------------ Back office Partners -----------------
				=========================================================
			*/

			'/espace-partenaires':
			{
				component: PartnerAccessPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE',
					'Partenaire'
				]
			},

			'/espace-partenaires/:partenaire':
			{
				component: PartnerModificationPage,
				permissions:
				[
					'Membre de synergies',
					'EC', 'Administrateur de CE',
					'Membre de CE',
					'Partenaire'
				]
			},

			/*
				=========================================================
				--------------------- Front website ---------------------
				=========================================================
			*/

			'/':
			{
				component: DashboardPage
			},

			'/avantages-et-services':
			{
				component: DashboardPage
			},

			'/contact':
			{
				component: DashboardPage
			},

			'/login':
			{
				component: LoginPage
			},

			'/login/application/:token':
			{
				component: AppTokenLoginPage
			},

			'/confirmer-mon-inscription/:token':
			{
				component: RegistrationConfirmationPage
			},

			'/inscription':
			{
				component: RegistrationPage
			},

			'/mot-de-passe-oublie':
			{
				component: PasswordRecoveryPage
			},

			'/nouveau-mot-de-passe':
			{
				component: NewPasswordPage
			},

			'/nouveau-mot-de-passe/:token':
			{
				component: NewPasswordPage
			},

			'/annulation-de-connexion/:token':
			{
				component: CancelLoginPage
			},

			'/maintenance':
			{
				component: MaintenancePage
			},

			'/renouvellement-partenaire/:token':
			{
				component: PartnersRenewalPage
			}
		};
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange,
			global: true
		});

		app.push(
		{
			event: 'sessionChange',
			cb: app.getThemeColors,
			global: true
		});

		qwest.post('/get-session')
		.then(function (xhr, response)
		{
			app.state.session = response || { permissions: { title: 'not_auth' } };

			app.state.session_fetched = true;

			if ([true, 'true'].includes(app.state.session.permissions.pay))
			{
				getCart();
				getOrderProcess();
			}

			app.emit('sessionChange', { label: 'initState' });
		})
		.catch(function (error, xhr, response)
		{
			console.error(error);
		});

		function getCart ()
		{
			qwest.post('/cart/get')
			.then(function (xhr, response)
			{
				app.state.cart = response.cart;

				app.state.cart_fetched = true;

				app.emit('cartChange', { label: 'initState' });
			})
			.catch(function (error, xhr, response)
			{
				console.error(error);
			});
		}

		function getOrderProcess ()
		{
			qwest.post('/order-process/get')
			.then(function (xhr, response)
			{
				app.state.order_process = response.order_process;

				['billing', 'shipping', 'payment']
				.forEach(function (prop)
				{
					var data = { };

					Object.keys(app.state.order_process[prop])
					.forEach(function (field)
					{
						const pattern = prop + '[' + field + ']';

						data[pattern] = app.state.order_process[prop][field];
					});

					app.state.order_process[prop] = data;
				});

				app.state.order_process.fetched = true;

				app.emit('serverOrderProcessUpdate',
				{
					label: 'initState',
					response: response
				});
			})
			.catch(function (error, xhr, response)
			{
				console.error(error);
			});
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange,
			global: true
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: app.getThemeColors,
			global: true
		});
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.permissions) return;

		component.setState(
		{
			permissions: app.state.session.permissions,
			auth_id: app.state.session.id
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let routes = [];

		Object.keys(component.routes).forEach(function (path, i)
		{
			let page_component     = component.routes[path].component;
			let exact              = component.routes[path].exact !== false;
			let access_permissions = component.routes[path].permissions;

			if (access_permissions && state.auth_id)
			{
				if (access_permissions.includes(state.permissions.title) === false)
				{
					routes.push
					(
						<Route exact={ exact } path={ path }
							component={ NotAllowedPage } key={ i } />
					);

					return;
				}
			}

			routes.push
			(
				<Route exact={ exact } path={ path }
					component={ page_component } key={ i } />
			);
		});

		let output =
		(
			<Router>
				<Switch>

					{ routes }

				</Switch>
			</Router>
		);

		return output;
	}
}